import * as React from 'react';
import { SampleBase } from '../../syncfusion/sample-base';
import { DashboardLayoutComponent, PanelDirective, PanelsDirective } from '@syncfusion/ej2-react-layouts';
//import { ComboBoxComponent } from '@syncfusion/ej2-react-dropdowns';
import { DataManager, WebApiAdaptor, Query, Predicate } from '@syncfusion/ej2-data';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import { /* config, */number_format } from '../../_helpers'
import { authenticationService } from '../../_services'
import { MapAjax } from '@syncfusion/ej2-maps';
import { MapsComponent, LayersDirective, LayerDirective, MarkersDirective, MarkerDirective, Marker, Legend as MapsLegend, MapsTooltip } from '@syncfusion/ej2-react-maps';
import './dashBoardOxi.css';
import * as data from './default-datasource.json';
import { AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationLegend, Legend, PieSeries, AccumulationTooltip, SeriesCollectionDirective, AccumulationDataLabel, ChartComponent, ColumnSeries, Category, SeriesDirective, Tooltip, DataLabel, DateTime, SplineAreaSeries, Inject } from '@syncfusion/ej2-react-charts';
import { setCulture,loadCldr,L10n } from '@syncfusion/ej2-base';
import * as gregorian from 'cldr-data/main/es-CO/ca-gregorian.json';
import * as numbers from 'cldr-data/main/es-CO/numbers.json';
import * as timeZoneNames from 'cldr-data/main/es-CO/timeZoneNames.json';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as weekData from 'cldr-data/supplemental/weekData.json';
import * as L10n_es from '@syncfusion/ej2-locale/src/es.json'
setCulture("es-CO");
L10n.load({"es-CO":L10n_es.es});
let g_datos;
//let pivotDataSettings = pivotSettings;
//let v_total;
//let g_data =datadash;
//let g_data = consultar(config.HostUrl + "analisis/resumen?cosecha=1",authenticationService.currentUserValue.jwt_token);


export let expensedata = [
    {
        'UniqueId': 'T100003',
        'DateTime': new Date(1488359820000),
        'Category': 'Food',
        'PaymentMode': 'Cash',
        'TransactionType': 'Expense',
        'Description': 'Confederate cush',
        'Amount': '900',
        'MonthShort': 'Mar',
        'MonthFull': 'March, 2017',
        'FormattedDate': '03/01/2017 08:53 PM',
        'Device': 'Tablet',
        'text':'33.3%'
    }, {
        'UniqueId': 'T100004',
        'DateTime': new Date(1491038220000),
        'Category': 'Transportation',
        'PaymentMode': 'Credit Card',
        'TransactionType': 'Expense',
        'Description': 'Public and other transportation',
        'Amount': '1200',
        'MonthShort': 'Apr',
        'MonthFull': 'April, 2017',
        'FormattedDate': '04/01/2017 10:44 AM',
        'Device': 'Desktop',
        'text':'44.5%'
    }, {
        'UniqueId': 'T100005',
        'DateTime': new Date(1493630220000),
        'Category': 'Transportation',
        'PaymentMode': 'Cash',
        'TransactionType': 'Expense',
        'Description': 'Public and other transportation',
        'Amount': '600',
        'MonthShort': 'May',
        'MonthFull': 'May, 2017',
        'FormattedDate': '05/01/2017 03:25 PM',
        'Device': 'Mobile',
        'text':'22.2%'
    },
];
export let data1 = [
    { x: new Date(2002, 0, 1), y: 2.2 }, { x: new Date(2003, 0, 1), y: 3.4 },
    { x: new Date(2004, 0, 1), y: 2.8 }, { x: new Date(2005, 0, 1), y: 1.6 },
    { x: new Date(2006, 0, 1), y: 2.3 }, { x: new Date(2007, 0, 1), y: 2.5 },
    { x: new Date(2008, 0, 1), y: 2.9 }, { x: new Date(2009, 0, 1), y: 3.8 },
    { x: new Date(2010, 0, 1), y: 1.4 }, { x: new Date(2011, 0, 1), y: 3.1 }
];
export let data2 = [
    { x: new Date(2002, 0, 1), y: 2 }, { x: new Date(2003, 0, 1), y: 1.7 },
    { x: new Date(2004, 0, 1), y: 1.8 }, { x: new Date(2005, 0, 1), y: 2.1 },
    { x: new Date(2006, 0, 1), y: 2.3 }, { x: new Date(2007, 0, 1), y: 1.7 },
    { x: new Date(2008, 0, 1), y: 1.5 }, { x: new Date(2009, 0, 1), y: 2.8 },
    { x: new Date(2010, 0, 1), y: 1.5 }, { x: new Date(2011, 0, 1), y: 2.3 }
];

let datasource = data;
//let dataSourceDash;
let markers = [
    { name: 'Asia', latitude: 50.32087157990324, longitude: 90.015625 },
    { name: 'Australia', latitude: -25.88583769986199, longitude: 134.296875 },
    { name: 'Africa', latitude: 16.97274101999902, longitude: 16.390625 },
    { name: 'Europe', latitude: 49.95121990866204, longitude: 18.468749999999998 },
    { name: 'North America', latitude: 59.88893689676585, longitude: -109.3359375 },
    { name: 'South America', latitude: -6.64607562172573, longitude: -55.54687499999999 }
];


export class OXIDashboard extends SampleBase {
    constructor() {
        super(...arguments);
        this.cellSpacing = [5, 5];
        this.state = {
            data : null,
            loading : true
        };
        //debugger;
        this.CfgOptions = authenticationService.currentUserValue.usuario.configuracion.replace(/'/g,"\"");
        this.CfgOptions = this.CfgOptions.replace(/: False/g,": false");
        this.CfgOptions = this.CfgOptions.replace(/: True/g,": true");
        this.CfgOptions = JSON.parse(this.CfgOptions).dashboard[authenticationService.currentUserValue.usuario.idioma];
        /* this.maestroCosecha = [{id_cosecha:1, cosecha:'Cosecha201901', id_agricultor:2, id_cultivo:1},
                                {id_cosecha:2, cosecha:'Cosecha202001', id_agricultor:2, id_cultivo:1}] */
        /* this.maestroCosecha = new DataManager({
                                    url: config.HostUrl + this.CfgOptions[this.props.opcion].puerto + config.HostEndUrl + this.CfgOptions[this.props.opcion].endpointcosecha,
                                    adaptor: new WebApiAdaptor(),
                                    headers:[{ "Content-Type":  "application / json",
                                                "api-token": `${authenticationService.currentUserValue.jwt_token}`
                                            }],
                                    crossDomain: true
                                }); */
        // maps the appropriate column to fields property
        //this.fields = { text: 'cosecha', value: 'id_cosecha' };
        // set the value to select an item based on mapped value at initial rendering
        //this.value = 'Cosecha2021901';
        
    }

    onChange() {
        //debugger;
        this.startDateValue = this.dateRangeObj.startValue;
        this.endDateValue = this.dateRangeObj.endValue;
        const l_url = window.config.HostUrl + this.CfgOptions[this.props.opcion].puerto + window.config.HostEndUrl + this.CfgOptions[this.props.opcion].endpoint;
        this.setState({ data : null, loading : true });
        this.data = this.consultar(l_url,authenticationService.currentUserValue.jwt_token,{fecini:this.startDateValue,fecfin:this.endDateValue});
    }

    // call the change event's function after initialized the component.
    rendereComplete() {
 
    }
   /*  consulta_cosecha(datos, cosecha) {
        let itemMod;

        datos.map(function (item) {
            if (item.id_cosecha = cosecha) {
                itemMod = { bultos_cargados:item.bultos_cargados,
                            cards:[ {name:'Bultos Cosechados',value:item.bultos_cosechados},
                                    {name:'Bultos Cosechados en Lotes Terminados',value:item.bultos_cosechados_lotes_terminados},
                                    {name:'Bultos Cargados',value:item.bultos_cargados},
                                    {name:'Bultos Cargados en lotes terminados',value:item.bultos_cargados_lotes_terminados},
                                    {name:'Número recepciones',value:item.num_recepciones},
                                    {name:'Número recepciones en lotes terminados',value:item.num_recepciones_lotes_terminados},
                                    {name:'Número de Cargas',value:item.num_cargas},
                                    {name:'Número de Cargas en lotes terminados',value:item.num_cargas_lotes_terminados},
                                    {name:'Número de Vehiculos',value:item.num_vehiculos},
                                    {name:'Número de Vehiculos en lotes terminados',value:item.num_vehiculos_lotes_terminados}],
                            bigcards:[{name:'Bultos xHa',value:item.bultos_cosechados_lotes_terminados/item.area_terminada}],
                            area:[{tipo:'Cosechada',cantidad:item.area_terminada,porcentaje:(item.area_terminada/item.area_total)*100},{tipo:'Sin cosechar',cantidad:item.area_total-item.area_terminada,porcentaje:((item.area_total-item.area_terminada)/item.area_total)*100}],
                            lotes:[{tipo:'Cosechados',cantidad:item.num_lotes,porcentaje:(item.nume_lotes_terminados/item.num_lotes)*100},{tipo:'Sin cosechar',cantidad:item.num_lotes-item.num_lotes_terminados,porcentaje:((item.num_lotes-item.num_lotes_terminados)/item.num_lotes)*100}]};

            }
            
        });

        return itemMod;
    } */

    consulta_datos(item) {
        let itemMod;
       
        itemMod = { cards:[ {name:'Promedio valor visita',value:item[2].total[0].promedio_valor_visita},
                            {name:'Minimo valor visita',value:item[2].total[0].minimo_valor_visita},
                            {name:'Máximo valor visita',value:item[2].total[0].maximo_valor_visita}],
                    bigcards: [ {name:'Valor Visitas',value:item[2].total[0].valor_visita},
                                {name:'Visitas',value:item[2].total[0].visitas}],
                    //bigcards:[{name:'Bultos xHa',value:item.bultos_cosechados_lotes_terminados/item.area_terminada}],
                    pie1:item[0].dash,
                    chart1:item[1].pormes};
        return itemMod;
    };

    btnClick() {
        let proxy = this;
        let count = 8;
        let panel = [{
                'id': count.toString() + '_layout', 'sizeX': 1, 'sizeY': 1, 'row': 0, 'col': 0,
                content: '<span id="close" className="e-template-icon e-clear-icon"></span><div className="text-align">' + count.toString() + '</div>'
            }];
        count = count + 1;
        proxy.dashboardObj.addPanel(panel[0]);
    }
    load(args) {
        //debugger;
        let selectedTheme = window.location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.accumulation.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast');
        
    }
    Chartload(args) {
        let selectedTheme = window.location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.chart.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast');
        if (selectedTheme === 'highcontrast') {
            args.chart.series[0].marker.dataLabel.fill = '#000000';
            args.chart.series[1].marker.dataLabel.fill = '#000000';
        }
    }
    ;
    Mapload(args) {
        let selectedTheme = window.location.hash.split('/')[1];
        selectedTheme = selectedTheme ? selectedTheme : 'Material';
        args.maps.theme = (selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)).replace(/contrast/i, 'Contrast');
    }
    ;
    /* card1() {
        return (<div className="card">
                <span className="e-icons session"></span>
                <div className="card-content text">
                    Bultos Cosechados
                </div>
                <div className="card-content number">
                    {number_format(g_datos.bultos_cosechados,0,'.',',')}
                </div>
            </div>);
    }
    card2() {
        return (<div className="card">
            <span className="e-icons profile"></span>
            <div className="card-content text">
                Bultos Cosechados en lotes terminados
            </div>
            <div className="card-content number">
                {number_format(g_datos.bultos_cosechados_lotes_terminados)}
            </div>
        </div>);
    }
    card3() {
        return (<div className="card">
                <span className="e-icons views"></span>
                <div className="card-content text">
                    Bultos Cargados
                </div>
                <div className="card-content number">
                    {number_format(g_datos.bultos_cargados)}
                </div>
            </div>);
    } 
    
     card4() {
        debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    'Bultos Cargados en Lotes terminados'
                </div>
                <div className="card-content number">
                    {number_format(g_datos.bultos_cargados_lotes_terminados,',','.')}
                </div>
            </div>);
    } */
    card1() {
        debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[0].name}
                </div>
                <div className="card-content number">
                    ${number_format(g_datos.cards[0].value,',','.')}
                </div>
            </div>);
    }
    card2() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[1].name}
                </div>
                <div className="card-content number">
                    ${number_format(g_datos.cards[1].value,',','.')}
                </div>
            </div>);
    }
    card3() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[2].name}
                </div>
                <div className="card-content number">
                    ${number_format(g_datos.cards[2].value,',','.')}
                </div>
            </div>);
    }
    card4() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[3].name}
                </div>
                <div className="card-content number">
                    {number_format(g_datos.cards[3].value,',','.')}
                </div>
            </div>);
    }
    card5() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[4].name}
                </div>
                <div className="card-content number">
                    {number_format(g_datos.cards[4].value,',','.')}
                </div>
            </div>);
    }
    card6() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[5].name}
                </div>
                <div className="card-content number">
                    {number_format(g_datos.cards[5].value,',','.')}
                </div>
            </div>);
    }
    card7() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[6].name}
                </div>
                <div className="card-content number">
                    {number_format(g_datos.cards[6].value,',','.')}
                </div>
            </div>);
    }
    card8() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[7].name}
                </div>
                <div className="card-content number">
                    {number_format(g_datos.cards[7].value,',','.')}
                </div>
            </div>);
    }
    card9() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[8].name}
                </div>
                <div className="card-content number">
                    {number_format(g_datos.cards[8].value,',','.')}
                </div>
            </div>);
    }
    card10() {
        //debugger;
        return (<div className="card">
                
                <div className="card-content text">
                    {g_datos.cards[9].name}
                </div>
                <div className="card-content number">
                    {number_format(g_datos.cards[9].value,',','.')}
                </div>
            </div>);
    }
    bigcard1() {
        //debugger;
        return (<div className="big-card">
                <div className="big-card-content text">
                    {g_datos.bigcards[0].name}
                </div>
                <div className="big-card-content number">
                    ${number_format(g_datos.bigcards[0].value,',','.')}
                </div>
            </div>);
    }
    bigcard2() {
        //debugger;
        return (<div className="big-card">
                <div className="big-card-content text">
                    {g_datos.bigcards[1].name}
                </div>
                <div className="big-card-content number">
                    {number_format(g_datos.bigcards[1].value,',','.')}
                </div>
            </div>);
    }
    map() {
        return (<div style={{ height: "100%", width: "100%" }}>
        <MapsComponent id="maps" load={this.Mapload} zoomSettings={{
            enable: false
        }} legendSettings={{
            visible: false
        }}>
                        <Inject services={[Marker, MapsLegend, MapsTooltip]}/>
                        <LayersDirective>
                            <LayerDirective shapeData={new MapAjax('https://ej2.syncfusion.com/react/demos/src/dashboard-layout/world-map.json')} shapePropertyPath='continent' shapeDataPath='continent' dataSource={datasource.default} shapeSettings={{
                                    colorValuePath: 'color'}}>
                                                        <MarkersDirective>
                                                            <MarkerDirective visible={true} template='<div style="font-size: 12px;color:white;text-shadow: 0px 1px 1px black;font-weight: 500;width:50px">{{:name}}</div>' animationDuration={0} dataSource={markers}>
                                                            </MarkerDirective>
                                                            <MarkerDirective visible={true} shape='Image' imageUrl='./src/dashboard-layout/ballon.png' height={20} width={20} offset={{
                                    y: -10,
                                    x: 0}} 
                                    animationDuration={0} tooltipSettings={{
                                    visible: true,
                                    valuePath: 'name'}} 
                                    dataSource={[
                                    { latitude: 37.6276571, longitude: -122.4276688, name: 'San Bruno' },
                                    { latitude: 33.5302186, longitude: -117.7418381, name: 'Laguna Niguel' },
                                    { latitude: 40.7424509, longitude: -74.0081468, name: 'New York' },
                                    { latitude: -23.5268201, longitude: -46.6489927, name: 'Bom Retiro' },
                                    { latitude: 43.6533855, longitude: -79.3729994, name: 'Toronto' },
                                    { latitude: 48.8773406, longitude: 2.3299627, name: 'Paris' },
                                    { latitude: 52.4643089, longitude: 13.4107368, name: 'Berlin' },
                                    { latitude: 19.1555762, longitude: 72.8849595, name: 'Mumbai' },
                                    { latitude: 35.6628744, longitude: 139.7345469, name: 'Minato' },
                                    { latitude: 51.5326602, longitude: -0.1262422, name: 'London' }
                                ]}>
                                        </MarkerDirective>
                                </MarkersDirective>
                            </LayerDirective>
                        </LayersDirective>
                    </MapsComponent>
                </div>);
    }
/*     PivotGrafica() {
        return (<div style={{ height: "100%", width: "100%" }}>
              < PivotGrafica className='col'/>
            </div>); 
    }*/
    pie() {
        return (<div style={{ height: "100%", width: "100%" }}>
              <AccumulationChartComponent id='pie' legendSettings={{ visible: true }} enableSmartLabels={true} height="100%" width="100%" 
              // eslint-disable-next-line
              enableAnimation={false} selectionMode={"Point"} center={{ x: '50%', y: '50%' }} tooltip={{ enable: false, header: "<b>${point.x}</b>", format: 'Cantidad : <b>${point.y}</b>' }} 
              load={this.load.bind(this)}>
              <Inject services={[AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel]}/>
              <AccumulationSeriesCollectionDirective>
                {/* <AccumulationSeriesDirective dataSource={expensedata} name='Revenue' xName='Device' yName='Amount' explode={false} dataLabel={{
                 */}
                 <AccumulationSeriesDirective dataSource={g_datos.pie1} name='Regional' xName='mes' yName='visitas' explode={false} dataLabel={{
                    visible: true,
                        position: 'Inside', name: 'regional',
                        font: {
                            fontWeight: '600'
                        }
                    }} radius='100%' innerRadius='35%' palettes={['#357cd2', '#00bdae', '#e36593']}>
                {/* <AccumulationSeriesDirective dataSource={dataSourceDash} name='Revenue' xName='Lote' yName='Bultos' explode={false} dataLabel={{
                        visible: true,
                        position: 'Inside', name: 'text',
                        font: {
                            fontWeight: '600'
                        }
                    }} radius='100%' innerRadius='35%' palettes={['#357cd2', '#00bdae', '#e36593']}> */}
                </AccumulationSeriesDirective>
              </AccumulationSeriesCollectionDirective>
            </AccumulationChartComponent>
            </div>);
    }
    visitorsChart() {
        return (<div style={{ height: "100%", width: "100%" }}>
                <ChartComponent id='visitorsChart' style={{ textAlign: "center" }} load={this.Chartload.bind(this)} legendSettings={{ visible: false }} 
                primaryXAxis={{
                    valueType: 'DateTime',
                    labelFormat: 'y',
                    majorGridLines: { width: 0 },
                    intervalType: 'Years',
                    edgeLabelPlacement: 'Shift'
                }} primaryYAxis={{
                    labelFormat: '{value}',
                    lineStyle: { width: 0 },
                    maximum: 4, interval: 1,
                    majorTickLines: { width: 0 },
                    minorTickLines: { width: 0 }
                }} chartArea={{ border: { width: 0 } }}>
                        <Inject services={[SplineAreaSeries, DateTime, Legend]}/>
                        <SeriesCollectionDirective>
                            <SeriesDirective dataSource={data1} xName='x' yName='y' name='Jan' opacity={0.5} type='SplineArea' width={2} fill="rgb(239, 183, 202)">
                            </SeriesDirective>X
                            <SeriesDirective dataSource={data2} xName='x' yName='y' name='Feb' opacity={0.5} type='SplineArea' width={2} fill="rgb(14, 64, 152, .6)">
                            </SeriesDirective>
                            {/* <SeriesDirective dataSource={dataSourceDash} xName='Fecha' yName='Bultos' name='Ordenes de Servicio' opacity={0.5} type='SplineArea' width={2} fill="rgb(239, 183, 202)">
                            </SeriesDirective>  */}
                        </SeriesCollectionDirective>
                    </ChartComponent>

            </div>); 
    }
    pieChart() {
        return (<div style={{ height: "90%", width: "90%" }}>
                 <AccumulationChartComponent id='pieChart' legendSettings={{ visible: false }} enableSmartLabels={true} height="100%" width="100%" 
                 // eslint-disable-next-line
                    enableAnimation={false} selectionMode={"Point"} center={{ x: '50%', y: '50%' }} tooltip={{ enable: true, header: "<b>${point.x}</b>", 
                    /* format: 'Cantidad : <b>${point.y}%</b>' }} load={this.load.bind(this)}> */
                    // eslint-disable-next-line
                    format: 'Cantidad: <b>${point.y}</b>' }} load={this.load.bind(this)}>
                    <Inject services={[AccumulationLegend, PieSeries, AccumulationTooltip, AccumulationDataLabel]}/>
                    <AccumulationSeriesCollectionDirective>
                    {/* AccumulationSeriesDirective dataSource={[
                        { 'x': 'Desktop', y: 37, text: '60%' }, { 'x': 'Mobile', y: 17, text: '10%' },
                        { 'x': 'Tablet', y: 19, text: '20%' } */}
                    <AccumulationSeriesDirective dataSource={g_datos.pie1} xName='regional' yName='visitas' explode={true} 
                    explodeIndex={2} explodeOffset={"10%"} dataLabel={{
                        visible: true,
                        position: 'Inside', name: 'regional',
                        font: {
                            fontWeight: '600',
                            format: '#0.00'
                        }
                        }} radius='90%'>
                    {/* <AccumulationSeriesDirective dataSource={this.data} 
                            xName='depto' yName='idordser' explode={true} explodeIndex={2} explodeOffset={"10%"} dataLabel={{
                            visible: true,
                            position: 'Inside', name: 'text',
                            font: {
                                fontWeight: '600'
                            }
                            }} radius='100%'> */}
                </AccumulationSeriesDirective>
              </AccumulationSeriesCollectionDirective>
            </AccumulationChartComponent>
            </div>);
    }
    colChart() {
        let pointRender = (args) => {
            let seriesColor = ['#00bdae', '#404041', '#357cd2', '#e56590', '#f8b883',
                '#70ad47', '#dd8abd', '#7f84e8', '#7bb4eb', '#ea7a57'];
            args.fill = seriesColor[args.point.index];
        };
        return (<div style={{ height: "100%", width: "100%" }}>
                  <ChartComponent id='colChart' style={{ textAlign: "center" }} load={this.Chartload.bind(this)} legendSettings={{ visible: false }} 
                        pointRender={pointRender} 
                        primaryXAxis={{ valueType: 'Category', interval: 1, majorGridLines: { width: 0 } }} 
                        primaryYAxis={{
                            majorGridLines: { width: 0 },
                            majorTickLines: { width: 0 }, lineStyle: { width: 0 }, labelStyle: { color: 'transparent' }
                        }} chartArea={{ border: { width: 0 } }} tooltip={{ enable: true }}>
                        <Inject services={[ColumnSeries, Legend, Tooltip, Category, DataLabel]}/>
                        <SeriesCollectionDirective>
                            <SeriesDirective dataSource={g_datos.chart1} xName='mes' yName='visitas' name='Visitas' type='Column' marker={{ dataLabel: { visible: true, position: 'Top', font: { fontWeight: '600'/* , color: '#ffffff'  */} } }}>
                            </SeriesDirective>
                            {/* <SeriesDirective dataSource={dataSourceDash} xName='Lote' yName='Bultos' name='Tablet' animation={{ enable: false }} marker={{ dataLabel: { visible: true, position: 'Top', font: { fontWeight: '600', color: '#ffffff' } } }}>
                            </SeriesDirective> */}
                        </SeriesCollectionDirective>
                    </ChartComponent>
            </div>);
    }
/*     pivotTemplate() {
              
        return (<div className="template">
            
            <PivotTableToolBar style={{ "height": "100%", "width": "100%" }} pv_id='PivotViewVentas' pts_id='pivot-table-section-ventas' dataSourceSettings={pivotDataSettings.ventas} opcion='ventas'  arch_json={true} />
        </div>);
    } */

    
    componentDidMount() {
        //this.data = this.consultar(config.HostUrl + this.CfgOptions[this.props.opcion].puerto + config.HostEndUrl + this.CfgOptions[this.props.opcion].endpoint + "?$ini='2020-01-01'&$fin='2020-01-31'",authenticationService.currentUserValue.jwt_token);
        this.endDateValue = new Date(new Date());
        this.startDateValue = new Date(new Date().setDate(this.endDateValue.getDate()-31));
        this.maxDateValue = new Date(new Date());
        
        this.data = this.consultar(window.config.HostUrl + this.CfgOptions[this.props.opcion].puerto + window.config.HostEndUrl + this.CfgOptions[this.props.opcion].endpoint ,authenticationService.currentUserValue.jwt_token,{fecini:this.startDateValue,fecfin:this.endDateValue});
    }

    async consultar(url,token,values) {
        var fetchHeaders={};
    
        if (token) {
            fetchHeaders= { "Content-Type": "application/json", "api-token": `${token}` };
        } 
/*         var requestOptions = { 
            method: 'GET',
            //mode: 'no-cors',
            headers: fetchHeaders,
            redirect: 'follow'
        }; */

        const fecini = values.fecini.getFullYear()+'-'+(values.fecini.getMonth()+1)+'-'+values.fecini.getDate();
        const fecfin = values.fecfin.getFullYear()+'-'+(values.fecfin.getMonth()+1)+'-'+values.fecfin.getDate();
        console.log(fecini)
        console.log(fecfin)
        console.log(values.fecini)
        console.log(values.fecfin)

        let predicate = new Predicate('ini', 'greaterthanorequal', fecini);
        predicate = predicate.and('fin', 'lessthanorequal', fecfin);
        var datos = new DataManager({ url: url, 
                        adaptor: new WebApiAdaptor(),
                        headers:[fetchHeaders],
                        crossDomain: true});
        let resp = await datos.executeQuery(new Query().where(predicate))
        .then(info => {
            this.setState({ data : info.actual, loading : false });
            return info;
        });
        
                        
        /* const resp = await fetch( url, requestOptions)
        .then(handleResponse)
        .then(info => {
            this.setState({ data : info, loading : false });
            return info;
        })
        .catch(err => console.log('Error de consulta de datos.'+err) ); */
        

        return resp
    }

    onClickDR() {
        console.log(this.dateRangeObj.endValue.getFullYear()+-+this.dateRangeObj.endValue.getMonth()+'-'+this.dateRangeObj.endValue.getDate())
        console.log(this.dateRangeObj.startValue.getFullYear())
    }

    render() {
        //debugger;
        loadCldr(numberingSystems.default, gregorian.default, numbers.default, timeZoneNames.default, weekData.default);

       /*  v_total=0;
        Object.keys(expensedata).forEach((key, index) => {
                v_total = v_total + parseFloat(expensedata[key].Amount); 
            }); */
        if (this.state.loading === true) {
            return (
                <div className="control-section" id="target_dash">
                    {/* <div className="col-lg-12 col-sm-12 col-md-12" id="dashboard_sidebar_section">
            
                        <div id="analytic_head">
                            <div className="header">
                                <div className="combo-content"> Resumen de Cosecha
                                            <ComboBoxComponent id="oxivisitas" dataSource={this.maestroCosecha} ref={(combobox) => { this.listObj = combobox; }} fields={this.fields} change={this.onChange.bind(this)} placeholder="Seleccione la cosecha" value={this.value} popupHeight="220px"/>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            
            );
        }
        else {
            //debugger;
            
            g_datos = this.consulta_datos(this.state.data);
            console.log('datos')
            console.log(g_datos)
            
            return (<div>
                <div className="control-section" id="target_dash">
                    <div className="col-lg-12 col-sm-12 col-md-12" id="dashboard_sidebar_section">
                
                        <div id="analytic_head">
                            <div className="header">
                                <div className="combo-content"> Resumen Visitas
                                    <DateRangePickerComponent id="daterangepicker" format='yyyy-MM-dd' locale='en'
                                    placeholder='Seleccione un rango' strictMode={true} 
                                    ref={(scope) => { this.dateRangeObj = scope; }} onClick = {this.onClickDR.bind(this)}
                                    change={this.onChange.bind(this)}
                                    startDate={this.startDateValue} endDate={this.endDateValue}  max={this.maxDateValue} />
                                </div>
                            </div>
                        </div>
                        
                {!this.state.loading &&
                    <div id="analytic_target">
                        <div className="sidebar-content">
                            <div className="dashboardParent">
                                <DashboardLayoutComponent id="analytic_dashboard" cellAspectRatio={100 / 85} cellSpacing={this.cellSpacing} columns={13} >
                                    <PanelsDirective>
                                    
                                        <PanelDirective sizeX={3} sizeY={1} row={0} col={3} content={this.card1}></PanelDirective>
                                        <PanelDirective sizeX={3} sizeY={1} row={0} col={6} content={this.card2}></PanelDirective>
                                        <PanelDirective sizeX={3} sizeY={1} row={0} col={9} content={this.card3}></PanelDirective>
                                        <PanelDirective sizeX={3} sizeY={2} row={0} col={0} content={this.bigcard1}></PanelDirective>
                                        <PanelDirective sizeX={3} sizeY={2} row={2} col={0} content={this.bigcard2}></PanelDirective>
                                        
                                        {/* <PanelDirective sizeX={3} sizeY={1} row={0} col={9} content={this.card4}></PanelDirective>
                                        <PanelDirective sizeX={3} sizeY={2} row={2} col={0} content={this.card5}></PanelDirective> */}
                                        {/* <PanelDirective sizeX={2} sizeY={1} row={4} col={2} content={this.card6}></PanelDirective>
                                        <PanelDirective sizeX={2} sizeY={1} row={4} col={4} content={this.card7}></PanelDirective>
                                        <PanelDirective sizeX={2} sizeY={1} row={4} col={6} content={this.card8}></PanelDirective>
                                        <PanelDirective sizeX={2} sizeY={1} row={4} col={8} content={this.card9}></PanelDirective>
                                        <PanelDirective sizeX={2} sizeY={1} row={4} col={10} content={this.card10}></PanelDirective> 
                                        <PanelDirective sizeX={6} sizeY={3} row={0} col={6} content={this.bigcard1}></PanelDirective>*/}
                                        {/* <PanelDirective sizeX={4} sizeY={5} row={1} col={0} content={this.map.bind(this)} header="<div>Regional Map</div>"></PanelDirective> */}
                                        {<PanelDirective sizeX={3} sizeY={3} row={1} col={3} content={this.pieChart.bind(this)} header="<div>Visitas por region</div>"></PanelDirective>}
                                        {/* <PanelDirective sizeX={8} sizeY={2} row={1} col={4} content={this.PivotGrafica.bind(this)} header="<div>Traffic History</div>"></PanelDirective> */}
                                        {/* <PanelDirective sizeX={8} sizeY={2} row={1} col={4} content={this.visitorsChart.bind(this)} header="<div>Traffic History</div>"></PanelDirective> */}
                                        {/* <PanelDirective sizeX={3} sizeY={3} row={0} col={3} content={this.pie.bind(this)} header="<div>Lotes</div>"></PanelDirective> */}
                                        {/* <PanelDirective sizeX={3} sizeY={3} row={1} col={3} content={this.pie.bind(this)} header="<div>Visita por regional</div>"></PanelDirective> */}
                                        <PanelDirective sizeX={6} sizeY={3} row={1} col={6} content={this.colChart.bind(this)} header="<div>Visitas por mes</div>"></PanelDirective>
                                        {/* <PanelDirective sizeX={5} sizeY={3} row={4} col={7} content={this.pieChart.bind(this)} header="<div>Useage Statistics</div>"></PanelDirective>
                                        */}
                                    </PanelsDirective>
                                </DashboardLayoutComponent>
                            </div>
                        </div>
                    </div>}
                </div>
                </div>
            </div>);
        }
    }
}

